import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";

gsap.registerPlugin(Draggable, InertiaPlugin);

export function initHallmarksDeck() {
  const track = document.querySelector(".hallmarks-track");
  const container = document.querySelector(".hallmarks-container");
  
  if (!track || !container) return;

  // Defer layout queries until the browser is idle to prevent forced reflow during critical render
  const deferInit = window.requestIdleCallback || ((cb) => setTimeout(cb, 120));
  deferInit(() => {
    setupHallmarks(track, container);
  });
}

function setupHallmarks(track, container) {
  // If all cards fit cleanly inside the container (desktop 4-column layout),
  // no dragging is needed so cards stay properly framed
  if (track.scrollWidth <= container.offsetWidth + 10) {
    track.style.cursor = "default";
    container.style.cursor = "default";
    return;
  }

  // Calculate max drag boundaries dynamically if overflow occurs
  const getBounds = () => {
    const diff = container.offsetWidth - track.scrollWidth;
    return {
      minX: diff < 0 ? diff - 40 : 0,
      maxX: 0
    };
  };

  const draggableInstance = Draggable.create(track, {
    type: "x",
    bounds: getBounds(),
    inertia: true,
    edgeResistance: 0.65,
    onDragStart: function() {
      track.style.cursor = "grabbing";
    },
    onDragEnd: function() {
      track.style.cursor = "grab";
    }
  });

  window.addEventListener("resize", () => {
    if (track.scrollWidth <= container.offsetWidth + 10) {
      if (draggableInstance && draggableInstance[0]) {
        draggableInstance[0].disable();
      }
      track.style.cursor = "default";
      container.style.cursor = "default";
      gsap.set(track, { x: 0 });
    } else {
      if (draggableInstance && draggableInstance[0]) {
        draggableInstance[0].enable();
        draggableInstance[0].applyBounds(getBounds());
      }
    }
  });
}
